import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dfd7539"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "intro-section"
};
const _hoisted_2 = {
  class: "intro-item-wrapper"
};
const _hoisted_3 = {
  class: "intro-item-content"
};
const _hoisted_4 = {
  class: "intro-item-subtitle"
};
const _hoisted_5 = {
  class: "intro-item-list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon intro-icon-mark"
}, null, -1));
const _hoisted_7 = ["name", "href"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-arrow"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intro, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.title,
      class: "intro-item"
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "intro-item-cover",
      style: _normalizeStyle({
        backgroundImage: `url(${item.img_url})`,
        backgroundSize: 'cover'
      })
    }, null, 4), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.subTitle), 1), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.desc, text => {
      return _openBlock(), _createElementBlock("li", {
        key: text,
        class: "intro-item-list-item"
      }, [_hoisted_6, _createTextVNode(_toDisplayString(text), 1)]);
    }), 128))]), _createElementVNode("a", {
      class: "intro-item-link",
      name: item.link.value,
      href: item.link.url
    }, [_hoisted_8, _createTextVNode(_toDisplayString(item.link.value), 1)], 8, _hoisted_7)])])]);
  }), 128))]);
}